import { getAccountId } from 'api/auth';
import { IDropZoneFiles } from 'components/shared/Assets/shared/Form/types';
import { ETripEvent } from 'detailsv2/structure';
import { mapMime2AssetType } from 'utils/asset';
import axios, { upload } from 'utils/axios';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';

export type TripEvent = {
  id: number;
  attachedPages: unknown[];
  data: unknown;
  datesRange: {
    start: string;
    end: string;
  };
  daysRange: {
    start: number;
    end: number;
  };
  endDate: string;
  endDay: number;
  icon: string;
  itineraryId: string;
  positions: number[];
  showChangedRoomOrPageTooltip: boolean;
  startDate: string;
  startDay: number;
  type: ETripEvent;
};

export const uploadFile = async (
  file: IDropZoneFiles,
  targetType: string,
  targetId: number,
): Promise<{ id: number }> => {
  const accountId = getAccountId();

  const blob = await fetch(file.url).then((r) => r.blob());
  const formData = new FormData();
  formData.append('file', new File([blob], file.filename));
  formData.append('type', mapMime2AssetType(file.mimeType)!);
  formData.append('target_type', targetType);
  formData.append('target_id', targetId.toString());

  const response = await upload(`/acc/${accountId}/magic_imports/calendar`, 'POST', formData);

  return response.data as { id: number };
};

const decoratedAxiosGet = axiosGetAutoCancelDecorator();
export const checkStatus = async (
  id: number,
  abortController: AbortController,
): Promise<{ status: 'pending' | 'processing' | 'completed' | 'failed'; data: TripEvent[] }> => {
  const accountId = getAccountId();
  return decoratedAxiosGet(`/acc/${accountId}/magic_imports/calendar/${id}`, { signal: abortController.signal }).then(
    ({ data }) => data,
  );
};

export const retryImport = async (id: number): Promise<any> => {
  const accountId = getAccountId();
  return axios.post(`/acc/${accountId}/magic_imports/calendar/${id}/retry`).then(({ data }) => data);
};

export const markAsInserted = async (id: number): Promise<void> => {
  const accountId = getAccountId();

  await axios.patch(`/acc/${accountId}/magic_imports/calendar/${id}`, {
    importedAt: new Date().toISOString(),
  });
};
